/* FlashAnimation.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./FlashAnimation.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { B75, B300 } from '@atlaskit/theme/colors';
var flashTime = 700;
var flashAnimation = null;
var containerStyle = null;
var flashStyle = null;
/**
 * Test id for wrapper FlashAnimation div
 */
export var RENDER_FLASHANIMATION_TESTID = 'flash-animation';
/**
 * Flash animation background component. See Reaction component for usage.
 */
export var FlashAnimation = function FlashAnimation(props) {
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_1bsb1osq _4t3i1osq", props.flash && "_y44vt91o", props.className]),
    "data-testid": RENDER_FLASHANIMATION_TESTID,
    style: {
      "--_770km1": ix("".concat(flashAnimation, " ").concat(flashTime, "ms ease-in-out"))
    }
  }, props.children);
};